import clsx from 'clsx';
import CustomizeSparkleIcon from './CustomizeSparkleIcon';

// Figma: 既定（円）のボタン本体グラデーション（135deg）
const GRADIENT =
  'linear-gradient(135deg, #1d4ed8 0%, #3b82f6 14.423%, #818cf8 52.885%, #38bdf8 98.558%)';

// Figma: ボタン背後のぼかしたカラーグロー
const GLOW_GRADIENT =
  'linear-gradient(119.12deg, #93c5fd 7.735%, #818cf8 35.912%, #60a5fa 64.088%, #bfdbfe 92.265%)';

type Props = {
  className?: string;
  onClick?: () => void;
};

/**
 * AIカスタマイズ FAB。
 * 既定: グラデーションの円 + 白いスパークルアイコン。
 * ホバー: 白背景のピルへ展開し、アイコン・テキストは primary（青）になる。
 * いずれも背後にぼかしたカラーグローを敷く。右端固定で左方向へアニメーション展開する。
 */
export default function CustomizeFab({ className, onClick }: Props) {
  return (
    <div className={clsx('group', className)}>
      {/* カラーグロー（ぼかし） */}
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-0.5 rounded-full opacity-75 blur-[18px]"
        style={{ backgroundImage: GLOW_GRADIENT }}
      />
      <button
        type="button"
        onClick={onClick}
        aria-label="AIをカスタマイズして再検索"
        className={clsx(
          'relative flex h-15 items-center overflow-hidden rounded-full bg-white transition-shadow duration-300',
          'shadow-[0px_0px_0px_1.738px_rgba(99,155,255,0.35)]',
          'group-hover:shadow-[0px_0px_1.1px_0px_rgba(138,56,245,0.26),0px_0px_4px_0px_rgba(0,0,0,0.1)]'
        )}
      >
        {/* 既定のグラデーション面（ホバーでフェードアウトして白地を見せる） */}
        <div
          aria-hidden
          className="absolute inset-0 rounded-full opacity-100 transition-opacity duration-300 group-hover:opacity-0"
          style={{ backgroundImage: GRADIENT }}
        />
        <span className="relative flex size-15 shrink-0 items-center justify-center">
          <CustomizeSparkleIcon
            size={26}
            className="text-white transition-all duration-300 ease-out group-hover:scale-110 group-hover:rotate-[18deg] group-hover:text-primary"
          />
        </span>
        <span className="relative max-w-0 overflow-hidden text-body-md font-bold whitespace-nowrap text-primary opacity-0 transition-all duration-300 ease-out group-hover:max-w-[240px] group-hover:pr-md group-hover:opacity-100">
          AIをカスタマイズして再検索
        </span>
      </button>
    </div>
  );
}
